// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import MoveToAnotherTreatment from './data'

export default function MoveToAnotherTreatmentFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/MoveToAnotherTreatment">
      <MoveToAnotherTreatment {...props}>
        {children}
      </MoveToAnotherTreatment>
    </Flow>
  )
}
